export default __webpack_public_path__ + "static/effectively-icon-0d0adfaf2d64cedfc731c2965e1cdf50.png";